import { theme as WebComponentsTheme } from '@acorns/web-components'
import { path as getForPath } from 'ramda'

export const theme = (path: string) => (props: any) =>
  getForPath(path.split('.'), props.theme) as string | number

export const style = (cb: (theme: typeof themeObj) => any) => (props: any) => cb(props.theme)

const themeObj = {
  ...WebComponentsTheme,
}

export type ThemeProps = {
  theme: typeof themeObj
}

export default themeObj

export const updateThemeColor = (desiredColor?: string) => {
  const color = desiredColor || themeObj.colors.white
  const selector = document.querySelector("meta[name='theme-color']")
  if (selector) {
    selector.setAttribute('content', color)
  } else {
    const meta = document.createElement('meta')
    meta.name = 'theme-color'
    meta.content = color
    document.head.appendChild(meta)
  }
}
